'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventSessionRoutes = [
  {
    path: 'sessions',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.session.list',
        props: true,
        component: () => import('../views/SessionListView.vue'),
      },
      // {
      //   path: ':sessionId',
      //   component: EmptyRouterView,
      //   props: true,
      //   children: [
      //     {
      //       path: '',
      //       name: 'event.session.detail',
      //       component: () => import('../views/SessionDetailView.vue'),
      //     },
      //   ],
      // },
    ],
  },
];

export const eventManageSessionRoutes = [
  {
    path: 'sessions',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.manage.session.list',
        props: true,
        component: () => import('../views/ManageSessionListView.vue'),
      },
      {
        path: 'add',
        name: 'event.manage.session.add',
        props: true,
        component: () => import('../views/ManageSessionAddView.vue'),
      },
      {
        path: ':sessionId',
        component: EmptyRouterView,
        props: true,
        children: [
          // {
          //   path: '',
          //   name: 'event.manage.session.detail',
          //   props: true,
          //   component: () => import('../views/ManageSessionDetailView.vue'),
          // },
          {
            path: 'edit',
            name: 'event.manage.session.edit',
            props: true,
            component: () => import('../views/ManageSessionEditView.vue'),
          },
        ],
      },
    ],
  },
];
